import React, {memo} from 'react';
import ShortDescription from '../../components/body/ShortDescription';

import {HomeCarousel} from './components';

// TODO: Complete carousel, home page
// TODO: Add right navigation
const Home = memo(() => {
  return (
    <div>
      <HomeCarousel />
      <ShortDescription />
    </div>
  );
});

export default Home;
